let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsIntersectedResult определяет структуру результата логической проверки на пересечение одного объекта другим
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsIntersectedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsIntersectedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsIntersectedResult";
  }
}

module.exports = IsIntersectedResult;